import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { fetchDocuments, fetchFacets, type LibraryParams } from '../api/libraryApi';

export function useDocumentsQuery(params: LibraryParams) {
  return useQuery({
    queryKey: queryKeys.documents.list(params),
    queryFn: ({ signal }) => fetchDocuments(params, signal),
    placeholderData: keepPreviousData,
  });
}

export function useFacetsQuery() {
  return useQuery({
    queryKey: queryKeys.documents.facets(),
    queryFn: ({ signal }) => fetchFacets(signal),
    staleTime: 30 * 60_000,
  });
}

const NEWEST: LibraryParams = { page: 1, pageSize: 3, q: '', assetClass: '', currency: '', analyst: '', from: '', to: '', sort: '' };

/** The newest reports, for "New research you can ask about" on the Ask Research home. */
export function useNewestReports() {
  return useQuery({
    queryKey: queryKeys.documents.list(NEWEST),
    queryFn: ({ signal }) => fetchDocuments(NEWEST, signal),
    staleTime: 5 * 60_000,
    select: (page) => page.items,
  });
}
